import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'store',
  namespaced: true,
  actions: {
    async updateStore({ rootState }, store) {
      const { data } = await defaultApi.patchStore({
        uuid: rootState.auth.info.uuid,
        store,
      })
      return data
    },
  },
}
